// Lineage conflict callout for the gate-review page.

import { useOptionalRichTooltipController } from '../richTooltips/RichTooltipProvider.jsx';

export function LineageConflictCard({
  id = 'lineage-conflict',
  title = 'Lineage conflict',
  sourceSystem,
  sourceRecord,
  canonicalEntity,
  canonicalEntityId,
  field,
  conflictNote,
  richTooltip = null,
  onOpen,
}) {
  const tooltip = useOptionalRichTooltipController();
  const active = Boolean(richTooltip?.surfaceId && tooltip?.isActive(richTooltip.surfaceId));
  const pinned = Boolean(richTooltip?.surfaceId && tooltip?.isPinned(richTooltip.surfaceId));
  const triggerProps =
    richTooltip && tooltip
      ? tooltip.getTriggerProps({
          surfaceId: richTooltip.surfaceId,
          payload: richTooltip,
          testIdPrefix: 'rich-tooltip',
          ariaLabel: `${title} lineage conflict details`,
        })
      : {};
  const TriggerTag = richTooltip ? 'button' : 'div';
  return (
    <article className="conflict-card lineage">
      <TriggerTag
        type={richTooltip ? 'button' : undefined}
        className={`conflict-card-trigger${active ? ' is-active' : ''}${pinned ? ' is-pinned' : ''}`}
        data-testid={`lineage-conflict-trigger-${id}`}
        {...triggerProps}
      >
        <header className="row spread">
          <div>
            <div className="eyebrow">Lineage · disputed mapping</div>
            <h4 className="card-title">{title}</h4>
          </div>
          <span className="chip red sm">
            <span className="chip-dot pulse" /> Reconciliation needed
          </span>
        </header>
        <div className="conflict-chain">
          <span className="conflict-chain-node">{sourceSystem || 'source system'}</span>
          <span className="conflict-chain-arrow" aria-hidden>
            →
          </span>
          <span className="conflict-chain-node">{sourceRecord || 'source record'}</span>
          <span className="conflict-chain-arrow" aria-hidden>
            →
          </span>
          <span className="conflict-chain-node target">
            {canonicalEntity || 'canonical entity'}
            {canonicalEntityId ? <span className="mono small"> · {canonicalEntityId}</span> : null}
          </span>
        </div>
        {field ? (
          <p className="muted small">
            Field: <span className="mono">{field}</span>
          </p>
        ) : null}
        {conflictNote ? <p className="conflict-note">{conflictNote}</p> : null}
      </TriggerTag>
      <footer className="conflict-footer">
        <button className="btn link" onClick={onOpen}>
          Open lineage drilldown →
        </button>
      </footer>
    </article>
  );
}
